import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { PdpSharedDetail } from './PdpSharedDetail';
import { PdpSharedConditionModalLoader } from '../PdpSharedModals/PdpSharedConditionModal/PdpSharedConditionModalLoader';
import { FormattedMessage } from 'react-intl';
import tracking from 'dibs-tracking';
import { Link } from 'dibs-elements/exports/Link';

const openConditionModal = setModalOpen => {
    tracking.trackEvent({
        category: 'product',
        action: 'view condition descriptions clicked',
    });

    setModalOpen(true);
};

export const PdpSharedDetailCondition = props => {
    const [modalOpen, setModalOpen] = useState(false);

    const { detailValues, currency, delimiter, itemId, relay } = props;
    return (
        <>
            <PdpSharedDetail
                detailValues={detailValues}
                currency={currency}
                delimiter={delimiter}
            />
            <div>
                <Link
                    onClick={() => openConditionModal(setModalOpen)}
                    dataTn="open-condition-modal"
                >
                    <FormattedMessage
                        id="pdpSharedDetailCondition.conditionModalLink"
                        defaultMessage="See Condition Descriptions"
                    />
                </Link>
                <div>
                    <PdpSharedConditionModalLoader
                        isOpen={modalOpen}
                        onClose={() => setModalOpen(false)}
                        environment={relay.environment}
                        itemId={itemId}
                    />
                </div>
            </div>
        </>
    );
};

PdpSharedDetailCondition.propTypes = {
    detailValues: PropTypes.array,
    delimiter: PropTypes.string,
    currency: PropTypes.string,
    relay: PropTypes.object.isRequired,
    itemId: PropTypes.string.isRequired,
};
